/* Copyright (c) 2023-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { HigSidebarAnimationState } from './nv-hig-sidebar.type';

export const AnimationStateMap: Record<
    HigSidebarAnimationState,
    { expand: boolean; text: boolean; shadow: boolean; icon: boolean }
> = {
    [HigSidebarAnimationState.Init]: { expand: false, text: false, shadow: false, icon: false },
    [HigSidebarAnimationState.Expanding]: { expand: true, text: true, shadow: true, icon: true },
    [HigSidebarAnimationState.Expanded]: { expand: true, text: true, shadow: true, icon: true },
    [HigSidebarAnimationState.Collapsing]: { expand: true, text: false, shadow: false, icon: false },
    [HigSidebarAnimationState.Collapsed]: { expand: false, text: false, shadow: false, icon: false }
};

/**
 * Flyout submenu hover timing constants.
 * Used by NvHigSidebarComponent to control when the submenu opens and closes
 * in response to mouse enter/leave events on page-nav items.
 */

/** Brief delay before the submenu opens after the user hovers over a nav item. */
export const HigSidebarSubMenuMouseOpenDelayMs = 200;

/** Delay before the submenu closes after the mouse leaves the trigger or panel.
 *  Gives the user time to move the cursor diagonally from the trigger into the submenu without it closing. */
export const HigSidebarSubMenuMouseCloseDelayMs = 150;

/** Keeps a pushed submenu clear of the viewport edge. */
export const HigSidebarSubMenuViewportMarginPx = 8;

/** Full accessible-label keys. The translated item text is provided as the `item` placeholder. */
export const HigSidebarItemWithNotificationAriaLabelKey = 'sidebar.itemWithNotification';
export const HigSidebarItemWithPageHighlightAriaLabelKey = 'sidebar.itemWithPageHighlight';
